import { render, staticRenderFns } from "./pricing-list.vue?vue&type=template&id=7fd10de4"
import script from "./pricing-list.vue?vue&type=script&lang=ts"
export * from "./pricing-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiModal: require('/vercel/path0/components/ui/modal.vue').default,UiIconInfo: require('/vercel/path0/components/ui/icon/info.vue').default})
